import { Navigate, Route, Routes } from "react-router";
import { Login } from "./pages/Login";
import { Signup } from "./pages/Signup";
import { Forgot } from "./pages/Forgot";
import { Dashboard } from "./pages/Dashboard";
import { Library } from "./pages/Library";
import { ExerciseDetail } from "./pages/ExerciseDetail";
import { Templates } from "./pages/Templates";
import { TemplateEditor } from "./pages/TemplateEditor";
import { Programs } from "./pages/Programs";
import { ProgramEditor } from "./pages/ProgramEditor";
import { Schedule } from "./pages/Schedule";
import { Session } from "./pages/Session";
import { History } from "./pages/History";
import { Settings } from "./pages/Settings";
import { BodyWeight } from "./pages/BodyWeight";
import { Progress } from "./pages/Progress";
import { Admin } from "./pages/Admin";
import { RequireAuth } from "./auth/RequireAuth";

export const App = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/signup" element={<Signup />} />
    <Route path="/forgot" element={<Forgot />} />

    <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
    <Route path="/library" element={<RequireAuth><Library /></RequireAuth>} />
    <Route path="/library/:id" element={<RequireAuth><ExerciseDetail /></RequireAuth>} />
    <Route path="/templates" element={<RequireAuth><Templates /></RequireAuth>} />
    <Route path="/templates/:id" element={<RequireAuth><TemplateEditor /></RequireAuth>} />
    <Route path="/programs" element={<RequireAuth><Programs /></RequireAuth>} />
    <Route path="/programs/:id" element={<RequireAuth><ProgramEditor /></RequireAuth>} />
    <Route path="/schedule" element={<RequireAuth><Schedule /></RequireAuth>} />
    <Route path="/session/:id" element={<RequireAuth><Session /></RequireAuth>} />
    <Route path="/history" element={<RequireAuth><History /></RequireAuth>} />
    <Route path="/progress" element={<RequireAuth><Progress /></RequireAuth>} />
    <Route path="/bodyweight" element={<RequireAuth><BodyWeight /></RequireAuth>} />
    <Route path="/settings" element={<RequireAuth><Settings /></RequireAuth>} />
    <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />

    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);
